import type { TCreateCadastrarClienteData } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class UpdateClienteService extends HttpService {
  async execute(id: string, cliente: TCreateCadastrarClienteData) {
    const response = await this.http.put(`api/v2/Cliente/alterar/${id}`, cliente)
    return response
  }
}
